<template>
  <div class="analysis_warp">
    <div class="top">
      <img src="@/assets/leftcontroller/返回.png"
             class="fixed_back_btn"
             @click="back"
             alt="">
      <div style="margin-left: 42%;">AI快速检测</div>
    </div>
     
    <div class="content">
      <div class="content_top">
        请选择你要检测的科目
      </div>
      <div class="content_middle">
        <div v-for="(item, index) in subjectList"
             :key="index"
             class="item"
             @click="handleClick(item,index)"
             :class="{ active: activeIndex == index }">
          {{ item.subject_name }}
        </div>

      </div>

    </div>
    <div class="content_bottom"
         @click="start">
      开始检测
    </div>
     

  </div>

</template>

  <script>
import { getPaper } from '@/api/quick.js'
import { getStudentSubject } from '@/api/subject.js'

export default {
  data() {
    return {
      showWindow: false,
      mapRef: null,
      subject_id: '',
      userinfo: null,
      ScoreRef: null,
      userId: '',
      subjectIndex: 0,
      subjectList: [],
      activeIndex: null,
      paper_duration: 0
    }
  },
  mounted() {
    this.userinfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.userId = Number(this.userinfo.user_id)
    this.getSubjectList()
  },
  beforeDestroy() {
    window.sessionStorage.removeItem('sessionNodeList')
  },
  methods: {
    async getSubjectList() {
      const { data } = await getStudentSubject()
      this.subjectList = data.list
    },
    toMyPaper() {
      this.$router.push('/quickPaper')
    },
    async start() {
      if (!this.subject_id) {
        this.$message.error('请选择科目')
        return
      }

      const { data } = await getPaper({ subject_id: this.subject_id })

      const params = {
        edu_paper_id: data.edu_paper_id,
        is_kujc: 1,
 
      }

      // window.sessionStorage.removeItem('testpaperCardIndex')
      // window.sessionStorage.removeItem('paper')
      // window.sessionStorage.removeItem('images')
this.$router.push('/doPaper?type=4&form=' + JSON.stringify(params))
       
    },
    back() {
      this.$router.push('/index')
    },
    handleClick(item, index) {
      this.activeIndex = index
      this.subject_id = item.subject_id
    },
    async submit() {
      const { status } = await addPost(this.$refs.FormRef.form1)
      if (status === 200) {
        this.$message.success('发帖成功')
        this.cancel()
      }
    },
    cancel() {
      // 关闭弹窗逻辑，根据你项目实现
      this.showWindow = false
    }
  }
}
</script>
 
<style lang="scss" scoped>
.analysis_warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f6f6;

  .top {
    img {
      width: 48rem;
      height: 48rem;
    }
    width: 1856rem;
    margin-top: 40rem;

    align-items: center;
    gap: 10rem;
    margin-left: 32rem;
    display: flex;
    border-radius: 32rem;
    background: #fff;
    height: 80rem;
    padding: 0 24rem;
    // justify-content: center;
    color: var(--light-333333, #333);
    text-align: center;

    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem; /* 150% */
  }
  .middle {
    img {
      width: 14rem;
      height: 14rem;
    }
    display: flex;
    width: 1200rem;
    margin-left: 360rem;
    height: 40rem;
    flex-shrink: 0;
    border-radius: 5rem;
    background: var(--Brand-Color_1, #e3f2fd);
    color: #000;
    text-align: center;
    align-items: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem; /* 150% */
    margin-top: 32rem;
    margin-bottom: 32rem;
  }
  .content_bottom {
    display: flex;
    width: 1200rem;
    height: 56rem;
    padding: 8rem 28rem;
    justify-content: center;
    align-items: center;
    gap: 6rem;
    cursor: pointer;
    border-radius: var(--Radius-XS, 8rem);
    background: var(--Brand-Color_6default, #2196f3);
    color: var(--light-ffffff, #fff);
    text-align: center;
    margin-left: 17.5%;
    font-size: 24rem;
    margin-top: 36rem;
    font-style: normal;
    font-weight: 400;
    line-height: 36rem; /* 150% */
  }
  .content {
    margin-left: 360rem;
    width: 1200rem;
    height: 382rem;
    border-radius: 32rem;
    background: #fff;

    .content_middle {
      display: grid;
      width: 422rem;
      margin-left: 32%;
      height: 182rem;
      gap: 32rem;
      padding-top: 53rem;
      grid-template: repeat(3, 1fr) / repeat(3, 1fr);
      .active {
        color: #fff !important;
        background: var(--Brand-Color_6default, #2196f3) !important;
      }
      .item {
        color: var(--Brand-Color_6default, #2196f3);
        display: flex;
        font-size: 16rem;
        width: 112rem;
        height: 40rem;
        // padding: 6rem 20rem;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        flex-shrink: 0;
        // grid-row: 1 / span 1;
        // grid-column: 1 / span 1;
        border-radius: var(--Radius-XS, 8rem);
        border: 1rem solid var(--2196-f-3, #2196f3);
        background: var(--light-ffffff, #fff);
      }
    }
    .content_top {
      display: flex;

      padding-top: 53rem;

      margin-top: 52rem;
      flex-direction: column;
      align-items: center;
      gap: 40rem;
      flex-shrink: 0;
      overflow: hidden;
      color: var(--light-333333, #333);
      text-align: center;
      text-overflow: ellipsis;

      font-size: 24rem;
      font-style: normal;
      font-weight: 600;
      line-height: 36rem; /* 150% */
    }
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
</style>